/* RESPONSIBLE TEAM: team-inbox-experience */
import { EntityType } from 'embercom/models/data/entity-types';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { type WorkflowObject } from 'embercom/objects/inbox/interfaces/workflow';

interface PriorityRemovedByWorkflowWireFormat {
  renderable_type: RenderableType;
  workflow: WorkflowObject;
}

export default class PriorityRemovedByWorkflow {
  readonly renderableType: RenderableType = RenderableType.PriorityRemovedByWorkflow;
  readonly workflow: WorkflowObject;

  constructor(workflow: WorkflowObject) {
    this.workflow = workflow;
  }

  get creatingEntity() {
    return { type: EntityType.Workflow, id: this.workflow.id || -1, object: this.workflow };
  }

  static deserialize(json: PriorityRemovedByWorkflowWireFormat): PriorityRemovedByWorkflow {
    return new PriorityRemovedByWorkflow(json.workflow);
  }
}
